export const QUESTIONS = [];

// eslint-disable-next-line no-multi-str
export const COVID_QUESTIONS_ERROR = 'We are sorry to hear that you or others \
are in contact with are not feeling well. \
Please refer to your state or federal Covid \
guidelines for recommended steps. And please \
reschedule after the proper quarantine, so we \
can all stay safe and healthy.';
export const COVID_QUESTIONS = [
  {
    label:
      'Have you had close contact with anyone who has COVID-19 in the last 14 days? Close contact means living int the same household as a person who has tested positive for COVID-19 for 15 minutes or more, or coming in direct contact with secretions (e.g., sharing utensils, being coughed on) from a person who has tested positive for COVID-19 while that person was symptomatic?',
    name: 'question_1',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ],
  },
  {
    label: 'Do you have a fever of 100°F or above?',
    name: 'question_2',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ],
  },

  {
    label:
      'Have you had any of the following symptoms in the past 10 days - not due to any other cause diagnosed by a healthcare provider: Fever or chills; dry cough or difficulty breathing; nausea or vomiting; diarrhea; muscle or body aches; fatigue; headache; sore throat; new loss of taste or smell; congestion or runny nose?',
    name: 'question_3',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ],
  },
  {
    label: 'Have you used medication to reduce a fever in the last 72 hours?',
    name: 'question_4',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ],
  },
  {
    label: 'Have you received your FIRST positive test or COVID-19 diagnosis in the last 10 days?',
    name: 'question_5',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ],
  },
];
